module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/iq-e549011efede8b5ba38b8b2af9915c2e.svg";